import React, { Fragment, useState } from "react";
import Header from "../../components/Header/Header";
import { Link } from "react-router-dom";
import PageTitle from "../../components/pagetitle/PageTitle";
import "./ContactPage.css";
import "./ContactTheme.css";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import ContactHelpSection from "./ContactHelpSection";
import ContactDetailsSections from "./ContactDetailsSections";
import ContactInfoSection from "./ContactInfoSection";


// import background image


const ContactPage: React.FC = () => {
  const [enquiryType, setEnquiryType] = useState("");
  const selectEnquiry = (value: string) => {
    setEnquiryType(value);
    document.getElementById("engineering-contact")?.scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth", block: "start" });
  };
  return (
    <Fragment>
      <div className='contact-redesign inner-page'>
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle="Contact us" pagesub="Contact us" />
            <section className="digicomm-contact-hero" aria-labelledby="contact-hero-title">
              <div className="container contact-hero-layout">
                <div className="digicomm-contact-hero-content">
                  <span className="sub-title">Contact DIGICOMM</span>
                  <h1 id="contact-hero-title">Let's Start the Right Conversation</h1>
                  <p>Every engineering challenge begins with a conversation. Whether you're exploring a new semiconductor product, expanding your engineering capabilities, seeking a trusted execution partner, or evaluating long-term collaboration, we're here to help.</p>
                  <p>Connect with Digicomm Semiconductor to discuss your objectives, exchange ideas, and discover how our engineering expertise can support your product development journey.</p>
                  <div className="digicomm-contact-hero-actions">
                    <a className="thm-btn agency-btn" href="#engineering-contact">
                      <span className="text">Talk to Our Engineering Team</span>
                      <span className="arrow" aria-hidden="true"><span className="arrow-icon">↗</span></span>
                    </a>
                    <Link className="digicomm-contact-secondary" to="/service">
                      Explore Our Engineering Capabilities <span aria-hidden="true">→</span>
                    </Link>
                  </div>
                </div>
                <aside className="contact-hero-direct" aria-label="Contact Digicomm directly">
                  <span className="contact-direct-symbol" aria-hidden="true">↗</span>
                  <a href="mailto:contactus@digicomm.org"><span>Email</span><strong>contactus@digicomm.org</strong><span aria-hidden="true">↗</span></a>
                  <a href="tel:+918088913516"><span>Phone</span><strong>+91-8088913516</strong><span aria-hidden="true">↗</span></a>
                  <div className="contact-direct-hours"><span>Business Hours</span><p>Monday–Friday<br />9:00 AM–6:00 PM</p></div>
                </aside>
              </div>
            </section>
            <ContactHelpSection selected={enquiryType} onSelect={selectEnquiry} />
            <ContactInfoSection />
            <ContactDetailsSections selectedEnquiryType={enquiryType} />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default ContactPage;
